"use client";

import { EVENTS } from "@/constants/tracking";
import { sendEvent } from "@/lib/utils";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

export default function PageViewTracking() {
  const pathname = usePathname();

  useEffect(() => {
    sendEvent({
      event: EVENTS.pageViewed,
      referrer: document.referrer,
      type: "B2E Activation",
    });
  }, [pathname]);

  return null;
}
